export function legacyUrlInitializer(): () => void {
	return () => {
		const hash = window.location.hash;
		// Check if the hash exists and starts with '#/' (indicating a legacy route)
		if (hash && hash.startsWith('#/')) {
			// Remove the '#' character
			const path = hash.substring(1);
			// Construct the new URL using the origin and the extracted path
			const newUrl = `${window.location.origin}${path}`;

			console.info(`[Legacy Redirect] Redirecting from ${window.location.href} to ${newUrl}`);

			// Replace the current history entry so the back button works intuitively
			// (or not, depending on preference, but replace is usually better for redirects)
			window.location.replace(newUrl);
		}
	};
}
